import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import debounce from "components/Forms/utils/debounce";
import { SpinnerBlack } from "components/Spinner";
import Textbox from "components/Forms/Elements/Textbox";
import Translate from "helpers/Translate";

function AutoSuggest({
  id = "auto",
  data = [],
  displayItemInList = "name",
  displayItemInTextbox = "",
  errorKey = "",
  errors = {},
  keyword = () => {},
  onSelect = () => {},
  onClose = () => {},
  placeholder,
  fieldValue = "",
  scoppedValue = null // Any value that should be passed along with the keyword
}) {
  const [selectedItem, setSelectedItem] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [touched, setTouched] = useState(false);
  const isLoading = useSelector(state => state.client.isLoadingClient);

  useEffect(() => {
    setSelectedItem(fieldValue);
  }, [fieldValue]);

  const handleKeywordChange = useCallback(
    debounce((value, scoppedValue) => {
      setShowSuggestions(true);
      setTouched(false);
      keyword(value, scoppedValue);
    }, 500),
    []
  );

  return (
    <>
      <div className="form-group">
        <div className="auto-suggest-input-wrapper">
          <Textbox
            type="text"
            id={id}
            name="auto"
            autoComplete="off"
            className="form-input"
            placeholder={placeholder}
            fieldValue={selectedItem}
            errorKey={errorKey}
            errors={errors}
            onClick={() => {
              setShowSuggestions(!showSuggestions);
            }}
            onChange={e => {
              setTouched(true);
              setSelectedItem(e.target.value);
              handleKeywordChange(e.target.value, scoppedValue);
            }}
            onKeyUp={e => {
              if (e.which === 27) {
                setShowSuggestions(false);
                setSelectedItem("");
                onClose();
              }
            }}
            onReturnKey={() => {}}
          />
          <span className="spinner">
            {(touched || isLoading) && <SpinnerBlack />}
          </span>
          {!isLoading && showSuggestions && (
            <i
              className="fas fa-times close pointer"
              onClick={() => {
                setShowSuggestions(false);
                setSelectedItem("");
                onClose();
              }}
            ></i>
          )}
        </div>

        {!isLoading && showSuggestions && (
          <div className="suggestions-outer" style={{ zIndex: 450 }}>
            <div className="suggestions">
              <ul>
                {data?.length > 0 &&
                  data.map((item, idx) => (
                    <li
                      key={idx}
                      onClick={() => {
                        if (displayItemInTextbox) {
                          setSelectedItem(item[displayItemInTextbox]);
                        } else {
                          setSelectedItem(item[displayItemInList]);
                        }
                        setShowSuggestions(false);
                        onSelect(item);
                      }}
                    >
                      {item[displayItemInList]}
                    </li>
                  ))}
                {data && data.length === 0 && (
                  <li
                    className="no-results"
                    onClick={() => {
                      setShowSuggestions(false);
                    }}
                  >
                    {Translate({ id: "no_results_to_show" })}
                  </li>
                )}
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

AutoSuggest.propTypes = {
  data: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  displayItemInList: PropTypes.string.isRequired,
  displayItemInTextbox: PropTypes.string,
  keyword: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  scoppedValue: PropTypes.any
};

export default AutoSuggest;
